module.exports = __webpack_public_path__ + "img/person_outlined.77e01f8f.svg";